<template>
  <v-container>
    <v-row data-cy="myReleaseNoteTable">
      <v-col sm="12">
        <h2 class="title font-weight-thin mt-0 mb-2">My Release Notes</h2>
        <v-card>
          <v-card-text>
            <v-tabs v-model="currentTab">
              <v-tab key="assigned" data-cy="uatDashboard__myReleaseNotesTab--assigned">Assigned</v-tab>
              <v-tab key="reported" data-cy="uatDashboard__myReleaseNotesTab--reported">Reported</v-tab>
              <v-tab-item key="assigned">
                <widget-assigned></widget-assigned>
              </v-tab-item>
              <v-tab-item key="reported">
                <widget-reported></widget-reported>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WidgetAssigned from "./WidgetAssigned";
import WidgetReported from "./WidgetReported";

export default {
  components: {
    WidgetAssigned,
    WidgetReported,
  },
  computed: {
    theme() {
      return this.$store.state.session.theme;
    },
  },
  data() {
    return {
      currentTab: null,
    };
  },
};
</script>
